module.exports = __webpack_public_path__ + "static/assets/8a78c045d0aa3484d7e1028cd4a617f1.svg";